import { render } from "./App.vue?vue&type=template&id=3bafd808"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3bafd808&lang=scss"

import exportComponent from "/codebuild/output/src398903933/src/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__